import type { TFunction } from "i18next";

// The fixed labels of the versions nara-documents saves itself (and of the editors' exit save).
const LABEL_KEYS = new Map([
  ["Edit session", "documentHistory.labels.editSession"],
  ["Auto-save", "documentHistory.labels.autoSave"],
  ["Before restore", "documentHistory.labels.beforeRestore"],
  ["Title change", "documentHistory.labels.titleChange"],
]);

/** A version's label in the reader's language: a known server label is translated, any other is shown as is. */
export const versionLabel = (label: string | null | undefined, t: TFunction): string => {
  if (!label) return t("documentHistory.version");
  const key = LABEL_KEYS.get(label);
  return key ? t(key) : label;
};
